import React from 'react'
import HeaderSection from '../../../../components/common/Header/HeaderSection'
import PaymentTable from './WithdrawalTable'
import { Box } from '@chakra-ui/react';

const Liability = () => {
    return (
        <div>
            <HeaderSection
                title="View Withdrawal"
                breadcrumb={["Dashboard", "Voucher", "Withdrawal"]}
            />
            <Box p={6}>

                <PaymentTable />
            </Box>
        </div>
    )
}

export default Liability